enum MaritalStatus {
    Unknown	= 0,
	Single = 1,
	Married	= 2,
    Divorced = 3,
    Separated = 4,
    Widowed = 5,
}

export default MaritalStatus;